import { request, Paginated } from "utils/api";

// checkin from GET /owner/check-ins/visitors
export interface CheckIn {
    contactData: {
        city: string,
        fullName: string,
        postalCode: string,
        street: string,
        telephoneNumber: string,
    }
    endDate: string,
    personIdentifier: string,
    startDate: string,
}

// contact person from GET /owner/check-ins/visitors/overlaps
export interface ContactPerson {
    checkIn: CheckIn,
    hadCloseContact: boolean,
}

// fetch visitors for contact tracing (GET /owner/check-ins/visitors)
export const getCheckInsVisitors = (data: {
    clubId?: string,
    fromDate?: string,
    limit?: number,
    offset?: number,
    query?: string,
}) => request<Paginated<CheckIn>>({
    data,
    endpoint: "/owner/check-ins/visitors",
    method: "get",
});

// fetch overlapping visitors for contact tracing (GET /owner/check-ins/visitors/overlaps)
export const getCheckInsVisitorsOverlaps = (data: {
    clubId?: string,
    fromDate: string,
    limit?: number,
    offset?: number,
    personIdentifier: string,
}) => request<Paginated<ContactPerson>>({
    data,
    endpoint: "/owner/check-ins/visitors/overlaps",
    method: "get",
});

// export overlapping visitors for contact tracing (POST /owner/check-ins/visitors/overlaps/exports)
export const postCheckInsVisitorsOverlapsExport = (data: {
    clubId?: string,
    fromDate: string,
    personIdentifier: string,
}) => request<{ url: string }>({
    data,
    endpoint: "/owner/check-ins/visitors/overlaps/exports",
    method: "post",
});

// notify possible contacts (POST /owner/check-ins/case-notifications)
export const postCheckInsCaseNotifications = (data: {
    clubId?: string,
    fromDate: string,
    personIdentifier: string,
}) => request<{}>({
    data,
    endpoint: "/owner/check-ins/case-notifications",
    method: "post",
});
